import isEmpty from 'lodash/isEmpty';
import { Platform } from 'react-native';
import Config from 'react-native-config';
import {
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource,
  MhpDetails
} from 'modules/types/common';
import { JsonObj } from '@mhp/general-interface';

const DISPATCHER_INDICATOR = 'dispatcher-service';
export const ANDROID_LOCALHOST = '10.0.2.2';
export const isDispatcherUrl = (url?: string) => {
  return !!url && url.includes(DISPATCHER_INDICATOR);
};

export const platformURL = (url: string) => {
  if (url && url.includes('localhost') && Platform.OS === 'android') {
    return url.replace('localhost', ANDROID_LOCALHOST);
  }
  return url;
};

export const objectToQsParam = (objRaw: {} | undefined): string => {
  if (!objRaw || isEmpty(objRaw)) {
    return '';
  }
  return window.encodeURIComponent(window.btoa(JSON.stringify(objRaw)));
};

export const objectFromQsParam = (qsParamRaw: string | undefined): JsonObj | MhpDetails => {
  if (!qsParamRaw) {
    return {};
  }

  let ret = {};
  try {
    ret = JSON.parse(window.atob(window.decodeURIComponent(qsParamRaw || '')));
  } catch (err) {
    ret = {};
  }
  return ret;
};

export const getDispatcherUrl = (
  service: DispatcherCategoryService | '',
  authPrefix: DispatcherAuthPrefix,
  resource: DispatcherResource,
  endpointAndParams: DispatcherEndpoint | string = '',
  needsBase = false
) => {
  let url = `${service}${authPrefix}${resource}${endpointAndParams}`;

  if (needsBase) {
    url = `${Config.DISPATCHER_BASE_URL}${url}`;
  }
  return url;
};
